import { render, staticRenderFns } from "./deanInputSelectTime.vue?vue&type=template&id=058c8d1a&scoped=true"
import script from "./deanInputSelectTime.vue?vue&type=script&lang=ts"
export * from "./deanInputSelectTime.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelectTime.vue?vue&type=style&index=0&id=058c8d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c8d1a",
  null
  
)

export default component.exports